import React from 'react';
import { motion } from 'framer-motion';
import { DownloadCloudIcon } from 'lucide-react';
import { steps } from '../../data/site';
const stepAccents = ['bg-brand-cyan/10 text-brand-cyan', 'bg-brand-indigo/10 text-brand-indigo', 'bg-brand-violet/10 text-brand-violet'];
export function HowItWorks() {
  return <section id="how-it-works" className="w-full border-y border-navy-100 bg-brand-indigo/[0.035]" data-id="element-156" data-mp="3txguivz6ao7u">
      <div className="mx-auto max-w-content px-6 py-24" data-id="element-157" data-mp="brat2nt47hk4">
        <div className="max-w-2xl" data-id="element-158" data-mp="6uc0wat0hkok">
          <h2 className="text-3xl font-bold tracking-tight text-navy-800 sm:text-4xl" data-id="element-159" data-mp="6t98tzjydc72">
            How It Works
          </h2>
          <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-160" data-mp="lkj9lyt7vpc2" />
          <p className="mt-6 text-lg leading-relaxed text-navy-500" data-id="element-161" data-mp="uk68odyh4j1y">
            A straightforward purchase process, from selection through to
            electronic delivery.
          </p>
        </div>

        <ol className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-162" data-mp="24ds8mhiawwar">
          {steps.map((step, index) => <motion.li key={step.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="rounded-2xl border border-navy-100 bg-white p-8" data-id="element-163" data-mp="28eb2eh3r8cfl" data-mpi={index}>
              <span className={`inline-flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold ${stepAccents[index % stepAccents.length]}`} data-id="element-164" data-mp="2rc58am9l67tr">
                {index + 1}
              </span>
              <h3 className="mt-5 text-lg font-semibold text-navy-800" data-id="element-165" data-mp="361jke24jr3cu">
                {step.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-navy-500" data-id="element-166" data-mp="3b04jtzbz5j08">
                {step.description}
              </p>
            </motion.li>)}
        </ol>

        <div className="mt-10 overflow-hidden rounded-xl border border-brand-indigo/20 bg-white" data-id="element-167" data-mp="2la5zzt6p3uhm">
          <span aria-hidden="true" className="block h-1 w-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-168" data-mp="2gbkylqfpj4rl" />
          <div className="flex items-start gap-3 p-5" data-id="element-169" data-mp="2qa0ppteqie13">
            <DownloadCloudIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-indigo" aria-hidden="true" data-id="element-170" data-mp="342guozr74m4n" />
            <p className="text-sm font-medium leading-relaxed text-navy-700" data-id="element-171" data-mp="2z3nhz9jqgz5j">
              Digital delivery only — all purchases are fulfilled
              electronically.
            </p>
          </div>
        </div>
      </div>
    </section>;
}